import { FC } from 'react';
import { useFabricEditor } from '../../lib/FabricJs';
import { useHandleHistory } from '../../lib/FabricJs/hooks/useHandleHistory';
import Section, { ButtonGrid, PanelButton } from './Section';

type OrderAction =
  | 'bringToFront'
  | 'bringForward'
  | 'sendToBack'
  | 'sendBackwards';

const ACTIONS: { action: OrderAction; label: string }[] = [
  { action: 'bringToFront', label: 'To front' },
  { action: 'bringForward', label: 'Forward' },
  { action: 'sendToBack', label: 'To back' },
  { action: 'sendBackwards', label: 'Backward' },
];

const LayerOrder: FC = () => {
  const { canvas } = useFabricEditor();
  const { handleHistory } = useHandleHistory();

  const move = (action: OrderAction) => {
    const activeObject = canvas?.getActiveObject();
    if (!canvas || !activeObject) return;
    canvas[action](activeObject);
    handleHistory();
  };

  return (
    <Section title="Layer order">
      <ButtonGrid columns={2}>
        {ACTIONS.map(({ action, label }) => (
          <PanelButton key={action} onClick={() => move(action)}>
            {label}
          </PanelButton>
        ))}
      </ButtonGrid>
    </Section>
  );
};

export default LayerOrder;
